var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-file h-100"},[_c('b-row',{staticClass:"zip-files h-100"},[_c('b-col',[_c('text-editor',{attrs:{"hideTextArea":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }